module.exports = __webpack_public_path__ + "img/clock-history.d4cff28c.svg";